import { ITransferRequest, ITransferRequestStatus } from './../../../../_models/transfer-sections/ITransferRequest';
import { TransferRequestService } from './../../../../shared/services/transfer-request.service';
import { ToastrService } from 'ngx-toastr';
import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-transfer-request-form',
  templateUrl: './transfer-request-form.component.html'
})
export class TransferRequestFormComponent implements OnInit, OnChanges {
  @Input() transferRequest: ITransferRequest;
  @Output() closeForm: EventEmitter<any> = new EventEmitter();
  loading: boolean;
  title: string = 'Transfer Request Status';
  @Input() transferRequestStatus: ITransferRequestStatus;
  transferRequestStatusForm: FormGroup;

  constructor(private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private service: TransferRequestService,
    private modalService: NgbModal) {
    this.createTransferRequestForm();
  }

  ngOnInit() {
    if (this.transferRequest) {
      this.setValueTransferRequestForm();
    }
  }

  ngOnChanges() {
    if (this.transferRequest) {
      this.setValueTransferRequestForm();
    }
  }

  createTransferRequestForm() {
    this.transferRequestStatusForm = this.fb.group({
      id: [''],
      isROApproved: ['', Validators.required],
      roRemark: ['']
    });

    if (this.transferRequest) {
      this.setValueTransferRequestForm();
    }
  }

  setValueTransferRequestForm() {
    this.transferRequestStatusForm.patchValue({
      id: this.transferRequest.id,
      isROApproved: this.transferRequest.isROApproved,
      roRemark: this.transferRequest.roRemark
    });
  }

  save() {
    if (this.transferRequestStatusForm.valid) {
      this.loading = true;
      this.transferRequestStatus = Object.assign({}, this.transferRequestStatusForm.value);
      if (this.transferRequestStatus) {
        this.service.updateStatusRegion(this.transferRequestStatus).subscribe(() => {
          this.toastrService.success('Transfer request status updated successfully');
          this.closeForm.emit();
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

  close() {
    this.modalService.dismissAll();
  }
}
